import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Link } from 'react-router-dom';
import config from '../config';
import axios from 'axios';
import Swal from 'sweetalert2';

const ForgotPassword = () => {

  const [email,setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  
  const handlerLogin = async () => {
    try {
         const payload = {
            email: email,
        }
       
         const res = await axios.post(config.urlApi + '/forgot-password', payload)
  
        if (res.data.message === 'success') {
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'New password sent to your email.',
              });
            
           
        } else if (res.data.message === 'User not found'){
            Swal.fire({
                title: 'Sign In',
                icon: 'warning',
                text: 'ไม่พบข้อมูลในระบบ',
                timer: 2000,
                timerProgressBar: true
            })
        } 
    } catch (e) {
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: e.response?.data || 'Something went wrong!',
          });
    }
  }
  
  const validateEmail = () => {
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setEmailError('Please enter a valid email address');
    } else {
      setEmailError('');
    }
  };
  
  
  return (
    <div className="app-auth-shell">
      <div className="app-auth-card">
        <div className="app-auth-brand">
          <span>Account Recovery</span>
          <h3>ลืมรหัสผ่าน NetZero</h3>
          <p>กรอกอีเมลของคุณเพื่อรับรหัสผ่านใหม่ผ่านระบบ</p>
        </div>
            <div className="mb-3">
              <label>Email</label>
              <input
                type='email'
                className='form-control p-3 shadow-sm'
                placeholder='ระบุ อีเมล์ของคุณ'
                onChange={(e)=>setEmail(e.target.value)}
                onBlur={validateEmail}
              />
                {emailError && <p className='text-danger'>{emailError}</p>}
            </div>

            {email.length > 0 ? 
            <button className='btn btn-primary shadow-sm' onClick={handlerLogin}>
              <i className='fa-solid fa-right-to-bracket'></i> ยืนยัน
              </button>
              :
              <button className='btn btn-primary shadow-sm' disabled>
              <i className='fa-solid fa-right-to-bracket'></i> ยืนยัน
              </button>
              }

             <Link to='/login'><button className='btn btn-secondary ms-2 shadow-sm' type="button">
                <i className="fa-solid fa-lock"></i> กลับ
              </button> 
              </Link>
              <div className="app-auth-footer">Copyright © CMU 2026</div>
        </div>
    </div>
  );
}

export default ForgotPassword;
